import { render } from "./TopUpMpayError.vue?vue&type=template&id=12dd28ea&scoped=true"
import script from "./TopUpMpayError.vue?vue&type=script&lang=js"
export * from "./TopUpMpayError.vue?vue&type=script&lang=js"

import "./TopUpMpayError.vue?vue&type=style&index=0&id=12dd28ea&scoped=true&lang=scss"

import exportComponent from "/appl/bamboo/bamboo-agent-home-5/xml-data/build-dir/PORTAL-DREITVWEBUI-JOB1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dd28ea"]])

export default __exports__